import React, { useState, useEffect } from 'react';
import { connect } from 'react-redux';
import PropTypes from 'prop-types';

import { NoResourceError } from '../../../shared/components/components/ui/error404';
import ProspectContainer from './components/custom/ProspectContainer';


const ResourceAction = (props) => {
  const {
    resources,
    history,
    location,
    session,
  } = props;
  const [tag, setTag] = useState('');
  const brandName = session?.advertiser?.companyName || 'Brand';

  useEffect(() => {
    document.title = `${brandName} Brand Prospects`;
  }, [brandName]);

  const resource = resources.find(r => r.id === 'Prospect');
  if (!resource) {
    return (<NoResourceError resourceId="Prospect" />);
  }
  const action = null;

  return (<ProspectContainer
    filterVisible
    tag={tag}
    setTag={setTag}
    resource={resource}
    action={action}
    date={new Date()}
    history={history}
    location={location}
  />
  );
};
ResourceAction.propTypes = {
  resources: PropTypes.arrayOf(PropTypes.objectOf(PropTypes.any)).isRequired,
  history: PropTypes.objectOf(PropTypes.any).isRequired,
  location: PropTypes.objectOf(PropTypes.any).isRequired,
  session: PropTypes.objectOf(PropTypes.any).isRequired,
};

const mapStateToProps = state => ({
  resources: state.resources,
  session: state.session,
});

export default connect(mapStateToProps)(ResourceAction);
